import React, { useEffect, useMemo, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
import SearchInputField from './SearchInputField';

const SEARCH_DEBOUNCE_MS = 400;

export default function TableToolbar(props) {
    // extract props
    const {
        showSearch = true,
        searchLabel = '検索',
        onClickSearch,
        filters,
        topActions,
        noMarginBottom,
        searchKeyword: _searchKeyword = '',
    } = props;

    /* --- SEARCH --- */

    const [serachKeyword, setSearchKeyword] = useState(_searchKeyword);
    const handleSearchKeywordChange = e => {
        setSearchKeyword(e.target.value);
    };

    const onClickSearchRef = useRef(onClickSearch);
    useEffect(() => {
        onClickSearchRef.current = onClickSearch;
    }, [onClickSearch]);

    const debouncedOnSearch = useMemo(
        () =>
            debounce(keyword => {
                onClickSearchRef.current && onClickSearchRef.current(keyword);
            }, SEARCH_DEBOUNCE_MS),
        []
    );

    useEffect(() => () => debouncedOnSearch.cancel(), [debouncedOnSearch]);

    const isFirstRun = useRef(true);
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        debouncedOnSearch(serachKeyword);
    }, [serachKeyword]);

    // Mirror an externally-driven keyword change (e.g. the search-results × button
    // clearing the term) back into the input.
    useEffect(() => {
        setSearchKeyword(prev => (prev === _searchKeyword ? prev : _searchKeyword));
    }, [_searchKeyword]);

    return (
        <div className={`tool-wrapper ${noMarginBottom ? 'mb-0' : ''}`}>
            <div className="panel-left">
                {showSearch && onClickSearch != null && (
                    <SearchInputField
                        value={serachKeyword}
                        onChange={handleSearchKeywordChange}
                        placeholder={searchLabel}
                    />
                )}
                {filters && <div className="filter-wrapper">{filters}</div>}
            </div>
            {topActions && <div className="panel-right">{topActions}</div>}
        </div>
    );
}
